import React, { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import AppointmentsList from "./AppointmentList";
import AppointmentDetails from "./AppointmentDetails";

const Appointments = () => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  return (
    <div className="flex flex-col gap-0 bg-custom-bg-purple w-full flex-1 h-full min-h-0 max-w-full">
      {/* Header with Chevron Toggle */}
    

      {/* Body */}
      <div className="fluid-0.5 flex flex-col flex-1 min-h-0 overflow-hidden">
        {/* Accordion Content for AppointmentsList */}
        

        {/* Appointment Details */}
        <div className="flex-1 overflow-auto">
          <AppointmentDetails />
        </div>
      </div>
    </div>
  );
};

export default Appointments;
